import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Sparkles, Clock, ArrowRight } from 'lucide-react';

const UNE_SLUG = 'quadricycle-lourd-l7e-permis-b1-guide-complet';
const UNE_VIDEO = '/assets/videos/une-l7e.mp4';

export default function UneMagazineHomeSection() {
  const [article, setArticle] = useState(null);
  useEffect(() => {
    api.getArticle(UNE_SLUG).then(setArticle).catch(() => {});
  }, []);
  if (!article) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 lg:px-6 mt-10 sm:mt-14" data-testid="une-magazine-home">
      <Link
        to={`/magazine/${article.slug}`}
        data-testid="une-magazine-home-link"
        className="group block rounded-2xl sm:rounded-3xl border border-red-700/40 overflow-hidden bg-[#0d0d0e] hover:border-red-500 transition"
      >
        <div className="grid sm:grid-cols-[1.1fr_1fr]">
          <div className="relative aspect-[16/10] sm:aspect-auto sm:min-h-[260px] overflow-hidden">
            <video
              autoPlay loop muted playsInline
              preload="metadata"
              poster={article.cover_image}
              className="absolute inset-0 w-full h-full object-cover"
              aria-hidden="true"
            >
              <source src={UNE_VIDEO} type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent sm:bg-gradient-to-r" />
            <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-red-600 text-white text-[10px] sm:text-[11px] font-bold tracking-widest font-mono-spec">
              <Sparkles size={11} /> À LA UNE · N°34
            </span>
          </div>
          <div className="p-4 sm:p-6 lg:p-8 flex flex-col justify-center">
            <div className="text-red-400 font-mono-spec text-[10.5px] sm:text-[11.5px] tracking-widest uppercase mb-2">
              Magazine · Octobre 2026 · {article.theme}
            </div>
            <h2 className="font-serif-editorial text-white text-[19px] sm:text-[24px] lg:text-[28px] leading-tight group-hover:text-red-100 transition-colors">
              {article.title}
            </h2>
            <p className="hidden sm:block text-white/60 text-[13px] leading-relaxed mt-3 line-clamp-3">{article.subtitle}</p>
            <div className="mt-3 sm:mt-4 flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5 text-white/40 text-[11px] font-mono-spec">
                <Clock size={11} /> {article.read_time_min} min · Légifrance & Sécurité Routière
              </span>
              <span className="inline-flex items-center gap-1.5 text-red-400 text-[12.5px] font-semibold group-hover:gap-2.5 transition-all">
                Lire <ArrowRight size={13} />
              </span>
            </div>
          </div>
        </div>
      </Link>
    </section>
  );
}
